import { render, staticRenderFns } from "./approve-warnings-modal.vue?vue&type=template&id=c927557c&scoped=true"
import script from "./approve-warnings-modal.vue?vue&type=script&lang=js"
export * from "./approve-warnings-modal.vue?vue&type=script&lang=js"
import style0 from "./approve-warnings-modal.vue?vue&type=style&index=0&id=c927557c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c927557c",
  null
  
)

export default component.exports